import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { MdArrowOutward, MdOutlineCloudDownload } from 'react-icons/md'
import { RevealLine, RevealUp } from './ui/Reveal'
import { ResumeModal } from './ResumeModal'

export const Header = () => {
  const [resumeOpen, setResumeOpen] = useState(false)

  return (
    <section className=' px-6 md:px-10'>
      <div className=' max-w-7xl mx-auto'>
        {/* meta row */}
        <div className=' flex flex-wrap items-center justify-between gap-3 py-5 border-b border-ink/10 text-[11px] md:text-xs font-medium uppercase tracking-[0.2em] text-ink/50'>
          <span>Software Engineer — Technical Writer</span>
          <span className=' flex items-center gap-2'>Lagos, Nigeria <span className=' text-mint-deep'>●</span> Open to work</span>
        </div>

        {/* giant headline */}
        <div className=' pt-10 md:pt-16 pb-8'>
          <p className=' font-mono text-sm text-ink/40 mb-4'>(Hello, I&apos;m)</p>
          <h1 className=' font-display font-semibold text-maroon leading-[0.88] tracking-[-0.03em] text-[clamp(2.5rem,13vw,10.5rem)]'>
            <RevealLine delay={0.05}>Wilson</RevealLine>
            <RevealLine delay={0.16}>
              Oluwa<span className=' italic font-normal text-mint-deep'>tomisin</span>
            </RevealLine>
          </h1>
        </div>

        {/* intro + actions */}
        <div className=' grid md:grid-cols-12 gap-8 items-end border-t border-ink/10 pt-10 pb-20'>
          <RevealUp delay={0.34} className=' md:col-span-5 flex flex-wrap gap-4'>
            <button onClick={() => setResumeOpen(true)} className=' group inline-flex items-center gap-2 bg-maroon text-cream text-sm font-medium px-7 py-3.5 rounded-full transition-colors duration-300 hover:bg-mint hover:text-panel'>
              Get Resume
              <MdOutlineCloudDownload className=' text-lg transition-transform duration-300 group-hover:translate-y-0.5' />
            </button>
            <Link to={'/contact'} className=' group inline-flex items-center gap-2 border border-ink/20 text-ink text-sm font-medium px-7 py-3.5 rounded-full transition-colors duration-300 hover:border-mint-deep hover:text-mint-deep'>
              Get in touch
              <MdArrowOutward className=' text-lg transition-transform duration-300 group-hover:rotate-45' />
            </Link>
          </RevealUp>
          <RevealUp delay={0.42} className=' md:col-span-6 md:col-start-7'>
            <p className=' text-lg md:text-2xl leading-relaxed text-ink/70 tracking-tight'>
              I turn ideas into interactive, user-friendly web experiences — from
              responsive interfaces to smooth motion and accessible, thoughtful detail.
            </p>
          </RevealUp>
        </div>
      </div>

      <ResumeModal open={resumeOpen} onClose={() => setResumeOpen(false)} />
    </section>
  )
}
